import { createFileRoute, redirect } from '@tanstack/react-router'
import { meQuery, resolveWorkspace } from '@/lib/queries'

/**
 * The root path holds no tenant of its own. It resolves one and hands over to
 * the workspace layout, which is where URL and session get reconciled.
 */
export const Route = createFileRoute('/_app/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery)
    const target = resolveWorkspace(me)

    // Signup always creates a personal workspace, so an empty list means the
    // last membership was revoked while this tab was open.
    if (!target) throw new Error('You are not a member of any workspace')

    throw redirect({ to: '/$org', params: { org: target.slug }, replace: true })
  },
})
